<p class="dsg-inspector-hint" *ngIf="!filters().length">
  Filter chosen components and texts by a column - only the ones you pick, not the whole dashboard.
</p>

<div class="dcf-card" *ngFor="let filter of filters(); let index = index; trackBy: trackById" [class.is-off]="filter.disabled">
  <div class="dcf-head">
    <label class="dsg-check">
      <input type="checkbox" [checked]="!filter.disabled" (change)="setEnabled(filter.id, $any($event.target).checked)" />
      <span>Filter {{ index + 1 }}</span>
    </label>
    <button type="button" class="dcf-remove" (click)="remove(filter.id)" matTooltip="Remove this filter" aria-label="Remove this filter">
      <mat-icon>delete_outline</mat-icon>
    </button>
  </div>

  <div class="dsg-field dsg-field-wide">
    <span>Entity</span>
    <ng-select #entitySel class="ss-select" [class.is-open]="!!entitySel.isOpen()" appendTo="body" ngClass="ss-dropdown-panel"
      [items]="datasets()" placeholder="Pick an entity" [clearable]="false"
      [loading]="data.datasets().status === 'loading'"
      [ngModel]="filter.entity || null" (ngModelChange)="setEntity(filter.id, $event)"></ng-select>
  </div>

  <div class="dsg-field dsg-field-wide">
    <span>Filter column</span>
    <ng-select #fieldSel class="ss-select" [class.is-open]="!!fieldSel.isOpen()" appendTo="body" ngClass="ss-dropdown-panel"
      [items]="columns(filter.entity)" [placeholder]="filter.entity ? 'Pick a column' : 'Pick an entity first'"
      [loading]="columnsLoading(filter.entity)" [readonly]="!filter.entity" [clearable]="false"
      [ngModel]="filter.field || null" (ngModelChange)="setField(filter.id, $event)"></ng-select>
  </div>

  <div class="dsg-field dsg-field-wide">
    <span>Operator</span>
    <ng-select #operatorSel class="ss-select" [class.is-open]="!!operatorSel.isOpen()" appendTo="body" ngClass="ss-dropdown-panel"
      [items]="operators" bindLabel="label" bindValue="value" [clearable]="false" [searchable]="false"
      [ngModel]="filter.operator || 'eq'" (ngModelChange)="setOperator(filter.id, $event, filter)"></ng-select>
  </div>

  <!-- Applied on Enter / blur: a half-typed value never reloads the targets. -->
  <label class="dsg-field dsg-field-wide" *ngIf="needsValue(filter)">
    <span>{{ isList(filter) ? 'Values' : 'Value' }}</span>
    <input type="text" [placeholder]="isList(filter) ? 'a, b, c' : 'Value'"
      [ngModel]="valueText(filter)" [ngModelOptions]="{ updateOn: 'blur' }"
      (ngModelChange)="setValue(filter.id, $event, filter)" (keydown.enter)="$any($event.target).blur()" />
  </label>

  <div class="dcf-targets">
    <span class="dcf-label">Filter targets</span>
    <ng-select #targetSel class="ss-select" [class.is-open]="!!targetSel.isOpen()" appendTo="body" ngClass="ss-dropdown-panel"
      [items]="targets()" bindLabel="label" bindValue="value" groupBy="group" [multiple]="true" [closeOnSelect]="false"
      [selectableGroup]="true" [selectableGroupAsModel]="false" placeholder="Components and texts to filter"
      [ngModel]="filter.targets" (ngModelChange)="setTargets(filter.id, $event)"></ng-select>
  </div>

  <p class="dcf-problem" *ngIf="problem(filter) as reason">{{ reason }}</p>
</div>

<button type="button" class="dcf-add" (click)="add()">
  <mat-icon>add</mat-icon>
  <span>Add canvas filter</span>
</button>
